import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class EmployeeAccountActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Base/User/UserBrowser")
	}

	render() {
		return (
			<Activity 
				name="employeeAccount"
				RenderedComponent={this.RenderedComponent}
				context="isEmployee"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(EmployeeAccountActivity)